// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrdersList_ordersList__CvIXg {
  width: 100%;
  padding-bottom: 50px;
}
@media (min-width: 1200px) {
  .OrdersList_ordersList__CvIXg {
    margin-top: 31px;
    padding-bottom: 0;
  }
}
.OrdersList_ordersList__title__trKao {
  margin-bottom: 12px;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 114%;
}
.OrdersList_ordersList__day__I1M9M {
  padding-top: 24px;
}
@media (min-width: 1200px) {
  .OrdersList_ordersList__day__I1M9M {
    padding: 0;
    margin-bottom: 16px;
  }
}
.OrdersList_ordersList__day__I1M9M:last-child {
  margin-bottom: 0;
}
.OrdersList_ordersList__headSk__690uF {
  border-radius: 4px;
  max-width: 208px;
  height: 32px;
  margin-top: 24px;
}
.OrdersList_ordersList__itemSk__LPI\\+a {
  margin-top: 8px;
  border-radius: 16px;
  width: 100%;
  height: 92px;
}

.OrdersList_nothingContent__UFqfl {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  line-height: 114%;
  position: absolute;
  margin: auto;
  width: 100%;
  top: 50%;
}
@media (min-width: 1200px) {
  .OrdersList_nothingContent__UFqfl {
    margin-top: auto;
    margin-top: 40px;
    position: initial;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/OrdersList/OrdersList.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,oBAAA;AACF;AACE;EAJF;IAKI,gBAAA;IACA,iBAAA;EAEF;AACF;AAAE;EACE,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAEJ;AACE;EACE,iBAAA;AACJ;AACI;EAHF;IAII,UAAA;IACA,mBAAA;EAEJ;AACF;AAAI;EACE,gBAAA;AAEN;AAEE;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;AAAJ;AAGE;EACE,eAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AADJ;;AAKA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;AAFF;AAIE;EAVF;IAWI,gBAAA;IACA,gBAAA;IACA,iBAAA;EADF;AACF","sourcesContent":[".ordersList {\n  width: 100%;\n  padding-bottom: 50px;\n\n  @media (min-width: 1200px) {\n    margin-top: 31px;\n    padding-bottom: 0;\n  }\n\n  &__title {\n    margin-bottom: 12px;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 114%;\n  }\n\n  &__day {\n    padding-top: 24px;\n\n    @media (min-width: 1200px) {\n      padding: 0;\n      margin-bottom: 16px;\n    }\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  &__headSk {\n    border-radius: 4px;\n    max-width: 208px;\n    height: 32px;\n    margin-top: 24px;\n  }\n\n  &__itemSk {\n    margin-top: 8px;\n    border-radius: 16px;\n    width: 100%;\n    height: 92px;\n  }\n}\n\n.nothingContent {\n  text-align: center;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 114%;\n  position: absolute;\n  margin: auto;\n  width: 100%;\n  top: 50%;\n\n  @media (min-width: 1200px) {\n    margin-top: auto;\n    margin-top: 40px;\n    position: initial;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ordersList": `OrdersList_ordersList__CvIXg`,
	"ordersList__title": `OrdersList_ordersList__title__trKao`,
	"ordersList__day": `OrdersList_ordersList__day__I1M9M`,
	"ordersList__headSk": `OrdersList_ordersList__headSk__690uF`,
	"ordersList__itemSk": `OrdersList_ordersList__itemSk__LPI+a`,
	"nothingContent": `OrdersList_nothingContent__UFqfl`
};
export default ___CSS_LOADER_EXPORT___;
